import { CONFIG } from './config.js';
import { dom } from './dom.js';

export const Resizer = {
  init() {
    let dragging = false;
    let startPos = 0;
    let startSize = 0;

    dom.divider.addEventListener('mousedown', (event) => {
      dragging = true;
      dom.divider.classList.add('dragging');
      const vertical = !dom.workspace.classList.contains('top-bottom');
      startPos = vertical ? event.clientX : event.clientY;
      startSize = vertical ? dom.inputPane.offsetWidth : dom.inputPane.offsetHeight;
      event.preventDefault();
    });

    document.addEventListener('mousemove', (event) => {
      if (!dragging) return;

      const vertical = !dom.workspace.classList.contains('top-bottom');
      const currentPos = vertical ? event.clientX : event.clientY;
      const delta = currentPos - startPos;
      const totalSize = vertical ? dom.workspace.offsetWidth : dom.workspace.offsetHeight;
      const nextSize = Math.max(
        CONFIG.minPaneSize,
        Math.min(totalSize - CONFIG.minPaneSize, startSize + delta)
      );

      dom.inputPane.style.flex = 'none';
      dom.outputPane.style.flex = '1';

      if (vertical) {
        dom.inputPane.style.width = `${((nextSize / totalSize) * 100).toFixed(2)}%`;
        dom.inputPane.style.height = '';
      } else {
        dom.inputPane.style.height = `${((nextSize / totalSize) * 100).toFixed(2)}%`;
        dom.inputPane.style.width = '';
      }
    });

    document.addEventListener('mouseup', () => {
      dragging = false;
      dom.divider.classList.remove('dragging');
    });
  },
};
